import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import {
  useGetSingleStatusLabelQuery,
  useUpdateSetatusLabelMutation,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  FormInput,
  FormSelect,
  FormTemplate,
} from "../../../../Components/Forms/InputTemplate";
const EditStatusLabelModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  // refresh,
  // setRefresh,
  id,
  onValidate = () => {},
}) => {
  const colorOptions = React.useMemo(
    () => [
      { value: 0, label: "Red" },
      { value: 1, label: "Yellow" },
      { value: 2, label: "Blue" },
      { value: 3, label: "Black" },
      { value: 4, label: "White" },
      { value: 5, label: "Green" },
    ],
    []
  );
  const { data } = useGetSingleStatusLabelQuery(id);
  const formMethods = useForm({
    defaultValues: {
      performanceStatusLabelName: "",
      fromScore: "",
      toScore: "",
      colorType: 0,
    },
    mode: "all",
  });
  React.useEffect(() => {
    if (data?.responseObject) {
      formMethods.reset({
        performanceStatusLabelName:
          data.responseObject.performanceStatusLabelName || "",
        fromScore: data.responseObject.fromScore || "",
        toScore: data.responseObject.toScore || "",
        colorType:
          colorOptions.find((c) => c.label === data.responseObject.colorType)
            ?.value ?? 0,
      });
    }
  }, [data, formMethods, colorOptions]);
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;
  const [onCreate] = useUpdateSetatusLabelMutation();
  const submit = async (data) => {
    const payload = {
      id,
      name: data.performanceStatusLabelName,
      fromScore: Number.isNaN(Number(data.fromScore))
        ? 0
        : parseInt(data.fromScore, 10),
      toScore: Number.isNaN(Number(data.toScore))
        ? 0
        : parseInt(data.toScore, 10),
      colorType: Number.isNaN(Number(data.colorType))
        ? 0
        : parseInt(data.colorType, 10),
    };
    try {
      const response = await onCreate(payload).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        onValidate();
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Edit</h4>
          <h1 className="text-[28px] font-[800]">Performance Status Label </h1>
          <p>
            Helps the system suggest appropriate actions based on performances
            score
          </p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormInput
                title={"Title"}
                camelCase={"performanceStatusLabelName"}
                placeholder={"select"}
              />
              <FormInput
                title={"Minimum Score-From"}
                camelCase={"fromScore"}
                placeholder={"select"}
                type={"number"}
              />
              <FormInput
                title={"Maximum Score-To"}
                camelCase={"toScore"}
                placeholder={"select"}
                type={"number"}
              />
              <FormSelect
                camelCase={"colorType"}
                title="Color"
                type={"number"}
                array={colorOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
                defaultValue={0}
              />
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  type={"submit"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Edit Status Label
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default EditStatusLabelModal;
